import React from "react";
import TabSection from "../IdfcLetterHead/TabSection";

function AppViewTab(props) {
  return (
    <>
      <div className="form-title">{props.heading1}</div>
      <div className="sub-title">{props.heading2}</div>
      <TabSection tabs={props.tabs} tabList={props.tabList} />
    </>
  );
}

export default AppViewTab;
